import { api } from '../api';
import {
  AccountBillingInformationGetResponse,
  AccountBillingInformationSaveRequest,
  AccountBillingInformationSaveResponse,
  BillingStatusResponse,
} from 'src/types/account-billing-information';

const getAccountBillingInformation = async (
  customerId: string
): Promise<AccountBillingInformationGetResponse> => {
  const response = await api({
    method: 'get',
    url: `/accounts/${customerId}/billing/information`,
  });
  return response.data;
};

const saveAccountBillingInformation = async (
  customerId: string,
  data: AccountBillingInformationSaveRequest
): Promise<AccountBillingInformationSaveResponse> => {
  const response = await api({
    method: 'put',
    url: `/accounts/${customerId}/billing/information`,
    data,
  });
  return response.data;
};

const getBillingStatus = async (customerId: string): Promise<BillingStatusResponse> => {
  const response = await api({
    method: 'get',
    url: `/accounts/${customerId}/billing/status`,
  });
  return response.data;
};

export const AccountBillingService = {
  getAccountBillingInformation,
  getBillingStatus,
  saveAccountBillingInformation,
};
